<template>
  <pt-goods-form :goods-form="form" class="pt-goods-form__withData" @submit="submit" :id="id" :is-edit="isEdit" :goodsGroup="goodsGroup" @typeChange="typeChange"
  :content="content" :afterSalesPolicieList="afterSalesPolicieList" @afterSalesPolicies="afterSalesPolicies" :vendors-organizations="vendorsOrganizations" :loading="loading"
  :goodsTypes="goodsTypes" @getGoodsTypeList="getGoodsTypeList" :goodsTypeLoading="goodsTypeLoading" :carriagePoliciesList="carriagePoliciesList"
  @getCarriagePolicies="getCarriagePolicies" :privacyPolicyList="privacyPolicyList" @getPrivacyPolicies="getPrivacyPolicies" @getCompany="getCompany" :saveLoading="saveLoading"
  :submitLoading="submitLoading" :companyList="companyList" :companyListWechat="companyListWechat" :businessDepartments="businessDepartments"></pt-goods-form>
</template>

<script>
import PtGoodsForm from './index'
export default {
  name: 'pt-goods-form__withData',
  components: {
    'pt-goods-form': PtGoodsForm
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      form: {},
      saveLoading: false,
      submitLoading: false,
      goodsGroup: [],
      groupType: '',
      content: '',
      afterSalesPolicieList: [],
      vendorsOrganizations: [],
      returnData: {},
      userLogin: '',
      loading: false,
      goodsTypes: [],
      goodsTypeLoading: false,
      carriagePoliciesList: [],
      privacyPolicyList: [],
      companyList: [],
      companyListWechat: [],
      businessDepartments: []
    }
  },
  computed: {
    goodsData () {
      return (this.form && this.form.goodsDTO && this.form.goodsDTO.goodsData) || {}
    }
  },
  watch: {
    groupType (val) {
      this.getGoodsGroup()
    }
  },
  methods: {
    getBusinessDepartment () {
      this.$store.dispatch('getBusinessDepartment').then(res => {
        this.businessDepartments = res
      }).catch(err => {
        this.$message.error(err || '获取业务部列表失败')
      })
    },
    // 获取分子公司列表
    getCompany (val) {
      if (val === 'MOLECULAR_COMPANY') {
        this.getBranchCompanyListWechat()
      } else if (val === 'THIRD_PARTY') {
        this.getVendorsOrganizations()
      }
    },
    getCompanyList () {
      let data = {
        type: 'BRANCH',
        pageableParam: {
          page: 0,
          size: 9999
        }
      }
      this.$store.dispatch('getBranchCompanyList', data).then(res => {
        // this.vendorsOrganizations = res.data
        this.companyList = res.data
      }).catch(err => {
        this.$message.error(err || '获取分子公司列表失败')
      })
    },
    getBranchCompanyListWechat () {
      let data = {
        pageableParam: {
          page: 0,
          size: 9999
        }
      }
      this.$store.dispatch('getBranchCompanyListWechat', data).then(res => {
        // this.vendorsOrganizations = res.data
        this.companyListWechat = res.data
      }).catch(err => {
        this.$message.error(err || '获取分子公司列表失败')
      })
    },
    typeChange (val) {
      this.groupType = val
    },
    //  获取商品详情
    getGoodsDetail () {
      this.loading = true
      let data = {
        id: this.id,
        isEdit: true
      }
      this.$store.dispatch('salesGoodsDetail', data).then(res => {
        this.loading = false
        res.goodsDTO.goodsData.allowCustomerOrder = res.goodsDTO.goodsData.allowCustomerOrder !== false
        this.form = res
        let goodsData = res.goodsDTO.goodsData
        this.groupType = res.goodsDTO.type
        this.content = goodsData.detail
        this.getGoodsTypeList(goodsData.goodsBelong)
      }).catch(err => {
        this.loading = true
        this.$message.error(err || '获取商品详情失败', 'error')
      })
    },
    submit (val) {
      this.saveLoading = true
      this.submitLoading = true
      this.$store.dispatch('createdGoodsDraft', val).then(data => {
        // doing something ...
        this.saveLoading = false
        this.submitLoading = false
        this.$message.success((this.isEdit ? '编辑' : '新建') + '商品成功')
        //
        // if (data.goodsDTO && data.goodsDTO.goodsData && data.goodsDTO.goodsData.tags && data.goodsDTO.goodsData.tags.length) {
        //   this.tagsObjects(data)
        // } else {
        //   history.go(-1)
        // }
        history.go(-1)
      }).catch(errorMessage => {
        this.saveLoading = false
        this.submitLoading = false
        this.$message.error(errorMessage || (this.isEdit ? '编辑' : '新建') + '商品失败')
      })
    },
    // 给商品打标签
    tagsObjects (data) {
      let tagsObj = []
      let tags = JSON.parse(JSON.stringify(data.goodsDTO.goodsData.tags))
      tags.forEach(item => {
        tagsObj.push({
          objectId: data.goodsDTO.goodsData.goodsId,
          objectType: '商品',
          tagId: item.id,
          tagName: item.name,
          tagUserId: this.userLogin,
          taggedSource: '商品标签更新',
          tagTime: new Date().getTime(),
          taggedType: 'BUSINESS_OBJECT',
          weight: item.weight
        })
      })
      this.saveLoading = true
      this.submitLoading = true
      this.$store.dispatch('tagsObjects', tagsObj).then(res => {
        this.$message.success('标签更新成功')
        this.saveLoading = false
        this.submitLoading = false
        history.go(-1)
      }).catch(err => {
        this.saveLoading = false
        this.submitLoading = false
        this.$message.error(err || '标签更新失败')
      })
    },
    // 获取商品分组列表
    getGoodsGroup () {
      let data = {
        example: {},
        pageable: {
          page: 0,
          size: 1000
        }
      }
      if (this.groupType) {
        data.example.type = this.groupType
      }
      this.$store.dispatch('getGoodsGroup', data).then(res => {
        // this.goodsGroup = res.data
        res.data.forEach(item => {
          if (!item.id !== 'goods-share') {
            this.goodsGroup.push(item)
          }
        })
      }).catch(err => {
        this.$message.error(err || '获取商品分组列表失败')
      })
    },
    // 获取售后政策列表
    afterSalesPolicies (selectId) {
      let data = {
        page: 0,
        size: 9999
      }
      this.$store.dispatch('afterSalesPolicies', data).then(res => {
        this.afterSalesPolicieList = res.data
        this.afterSalesPolicieList.unshift({
          id: 'null',
          name: '无'
        })
      }).catch(err => {
        this.$message.error(err || '获取售后政策列表失败')
      })
    },
    // 获取运费规则列表
    getCarriagePolicies () {
      let data = {
        page: 0,
        size: 9999
      }
      this.$store.dispatch('getCarriagePolicies', data).then(res => {
        this.carriagePoliciesList = res.data
      }).catch(err => {
        this.$message.error(err || '获取运费规则失败')
      })
    },
    // 获取隐私规则列表
    getPrivacyPolicies () {
      let data = {
        page: 0,
        size: 9999
      }
      this.$store.dispatch('getPrivacyPolicies', data).then(res => {
        this.privacyPolicyList = res.data
      }).catch(err => {
        this.$message.error(err || '获取隐私条款失败')
      })
    },
    // 获取第三方供应商列表
    getVendorsOrganizations () {
      let data = {
        page: 0,
        size: 9999
      }
      this.$store.dispatch('getVendorsOrganizations', data).then(res => {
        this.vendorsOrganizations = res
      }).catch(err => {
        this.$message.error(err || '获取第三方供应商列表失败')
      })
    },
    // 根据商品归属获取商品类型列表
    getGoodsTypeList (belong) {
      let data = {
        belong: belong || 'PLATFORM'
      }
      this.goodsTypeLoading = true
      this.$store.dispatch('getGoodsTypeList', data).then(res => {
        this.goodsTypeLoading = false
        this.goodsTypes = res
      }).catch(err => {
        this.goodsTypeLoading = false
        this.$message.error(err || '获取商品类型列表失败')
      })
    }
  },
  created () {
    this.userLogin = this.$auth.watch.data.userLogin
    this.afterSalesPolicies()
    this.getCarriagePolicies()
    this.getVendorsOrganizations()
    this.getCompanyList()
    this.getPrivacyPolicies()
    if (this.isEdit) {
      this.getGoodsDetail()
    } else {
      this.getGoodsGroup()
      this.getGoodsTypeList()
    }
    this.getBusinessDepartment()
  }
}
</script>
